import script from "./Trending.vue?vue&type=script&setup=true&lang=js"
export * from "./Trending.vue?vue&type=script&setup=true&lang=js"

import "./Trending.vue?vue&type=style&index=0&id=736ed96b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-736ed96b"]])

export default __exports__